import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn';

import ProviderIcon from 'components/ProviderIcon';

import { formatNumberWithLimit } from 'shared/helpers/formatNumber';

import './TableRow.scss';

const TableRow = ({ items }) => {
  const b = block('table-providers-row ');
  return (
    <div className={b('tr')}>
      {items?.map((el, index) => (
        <div key={`${el}_${index}`} className={b('td')}>
          {index === 0 && <ProviderIcon className={b('item-icon')} name={el.toLowerCase()} />}
          <span className={b('td-el')}>{index > 0 ? formatNumberWithLimit (el) : el}</span>
        </div>
      ))}
    </div>
  );
};

TableRow.propTypes = {
  items: PropTypes.array.isRequired,
};

export default TableRow;
